import Footer from "../../components/Footer"
import NavbarCustom from "../../components/navbar/NavbarCustom"

import { NavbarLink } from "../../components/navbar/NavbarLinkScroll"
import useApi from "../../hooks/useApi"
import { isAxiosError } from "axios"
import { PublicCourseSchema } from "../../api"
import { useEffect, useRef, useState } from "react"
import ARTE_CAN from "../../assets/images/ARTE_CAN.png"
import ARTA_CAN from "../../assets/images/ARTA_CAN.png"

import Loading from "../../components/Loading"
import { Alert, Button, Modal, TextInput } from "flowbite-react"
import { Link } from "react-router-dom"
import ModalCustomLanding from "../../components/modals/ModalCustomLanding"
import {
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/solid"
import useAuth from "../../hooks/useAuth"
import useAuthedApi from "../../hooks/useAuthedApi"

const Landing = () => {
  const [arte, setArte] = useState<PublicCourseSchema>()
  const [arta, setArta] = useState<PublicCourseSchema>()
  const [loading, setLoading] = useState(true)
  const { auth } = useAuth()
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [quantity, setQuantity] = useState<string>("1")
  const [validQuantity, setValidQuantity] = useState(false)
  const [quantityFocus, setQuantityFocus] = useState(false)
  const [errModalMsg, setErrModalMsg] = useState("")
  const errModalRef = useRef<HTMLInputElement>(null)

  const { CoursesApi } = useApi()
  const { CoursesAuthedApi } = useAuthedApi()

  const getArte = async () => {
    try {
      const response = await CoursesApi.coursesReadCourse("arte")
      if (!response.data) {
        console.log("Get course failed with unknown error")
        return
      }
      // console.log(JSON.stringify(response?.data))

      setArte(response.data)
      setLoading(false)
    } catch (err) {
      if (isAxiosError(err)) {
        if (!err?.response) {
          console.log("No server response")
        } else if (err.response?.status === 404) {
          console.log("We could not find that course")
        } else if (err.response?.status === 422) {
          console.log("Data validation error")
        } else {
          console.log("Get course failed with unknown error")
        }
      } else {
        console.log("Get course failed with unknown error")
      }
    }
  }

  const getArta = async () => {
    try {
      const response = await CoursesApi.coursesReadCourse("arta")
      if (!response.data) {
        console.log("Get course failed with unknown error")
        return
      }
      // console.log(JSON.stringify(response?.data))

      setArta(response.data)
      setLoading(false)
    } catch (err) {
      if (isAxiosError(err)) {
        if (!err?.response) {
          console.log("No server response")
        } else if (err.response?.status === 404) {
          console.log("We could not find that course")
        } else if (err.response?.status === 422) {
          console.log("Data validation error")
        } else {
          console.log("Get course failed with unknown error")
        }
      } else {
        console.log("Get course failed with unknown error")
      }
    }
  }

  const buy = async (slug: string, quantity: string) => {
    const q = parseInt(quantity)
    if (q < 1) {
      setErrModalMsg("Invalid data, quantity must be larger than 0")
      return
    }

    if (!auth?.user) {
      setShowAuthModal(true)
      return
    }

    try {
      const response = await CoursesAuthedApi.coursesBuyCourse({
        slug: slug,
        quantity: parseInt(quantity),
      })
      if (!response.data) {
        setErrModalMsg("Course purchase failed with unknown error")
        return
      }
      // console.log(JSON.stringify(response?.data))

      window.location.href = response.data.url
    } catch (err) {
      if (isAxiosError(err)) {
        if (!err?.response) {
          setErrModalMsg("No server response")
        } else if (err.response?.status === 400) {
          setErrModalMsg(err.response?.data.detail)
        } else if (err.response?.status === 404) {
          setErrModalMsg("We could not find that course")
        } else if (err.response?.status === 422) {
          setErrModalMsg("Data validation error")
        } else {
          setErrModalMsg("Course purchase failed with unknown error")
        }
      } else {
        setErrModalMsg("Course purchase failed with unknown error")
      }
      errModalRef.current?.focus()
    }
  }

  useEffect(() => {
    const q = parseInt(quantity)
    setValidQuantity(q >= 1)
  }, [quantity])

  useEffect(() => {
    getArte()
    getArta()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className="min-h-screen flex flex-col justify-between">
      <NavbarCustom>
        <NavbarLink href="#intro">Introduction</NavbarLink>
        <NavbarLink href="#certs">Certifications</NavbarLink>
      </NavbarCustom>
      <div className="mb-auto">
        <div className="container mx-auto">
          <section id="intro">
            <h1 className="mx-3 md:mx-0 mt-12 text-4xl md:text-6xl font-bold text-center dark:text-white">
              HACKTRICKS' LEARNING & CERTS
            </h1>
            <div className="mx-3 md:mx-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 justify-items-center dark:text-white">
              <div className="px-10 md:px-12 mt-5 md:mt-12">
                <h2 className="text-2xl font-bold text-center text-red-logo mb-7">
                  EXPERT INSTRUCTORS
                </h2>
                <p className="text-justify dark:text-white">
                  Learn from industry professionals with years of experience in
                  Pentesting, Red Teaming, Web Security, and of course, CI/CD &
                  Cloud Hacking. By learning from their insights and expertise,
                  you'll gain a strong foundation in cybersecurity principles
                  and practices, positioning yourself for success in the field.
                  Leverage their knowledge to stay ahead in the fast-paced
                  cybersecurity domain, ensuring your skills remain relevant and
                  in-demand.
                </p>
              </div>
              <div className="px-10 md:px-12 mt-5 md:mt-12">
                <h2 className="text-2xl font-bold text-center text-red-logo mb-7">
                  HANDS-ON TRAINING
                </h2>
                <p className="text-justify dark:text-white">
                  Gain practical experience with tens of different real-world
                  scenarios and tools per course. Our immersive and interactive
                  training modules are designed to develop your hacking skills,
                  helping you apply theoretical knowledge to address actual
                  security challenges effectively and confidently.
                </p>
              </div>
              <div className="px-10 md:px-12 mt-5 md:mt-12">
                <h2 className="text-2xl font-bold text-center text-red-logo mb-7">
                  HACKTRICKS BASED
                </h2>
                <p className="text-justify dark:text-white">
                  Our certifications, developed by the HackTricks team, are
                  recognized by thousands of security professionals who use
                  HackTricks as their go-to resource for staying up-to-date on
                  the latest trends, techniques, and best practices in the
                  industry. By leveraging the expertise of HackTricks, our
                  certifications ensure that you receive a high quality,
                  industry-relevant education that prepares you for real-world
                  challenges.
                </p>
              </div>
            </div>
          </section>
          <Modal
            show={showAuthModal}
            size="md"
            popup={true}
            onClose={() => {
              setShowAuthModal(false)
            }}
          >
            <Modal.Header />
            <Modal.Body>
              <div className="text-center">
                <ExclamationCircleIcon className="mx-auto mb-4 h-14 w-14 text-red-500 dark:text-red-200" />
                <h3 className="mb-5 text-lg font-normal text-white">
                  You need to sign in to make a purchase
                </h3>
                <div className="flex justify-center gap-4">
                  <Button
                    as={Link}
                    to="/signin"
                    outline={true}
                    className="ml-3 text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                  >
                    Sign in
                  </Button>
                  <Button
                    as={Link}
                    to="/signup"
                    className="ml-3 text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                  >
                    Create an account
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          {loading ? (
            <Loading />
          ) : (
            <>
              <section
                id="cert_arte"
                className="my-16 mx-3 md:mx-24 pt-10 border-dashed border-4 border-amber-500 rounded-3xl"
              >
                <div className="md:flex justify-center items-center">
                  <div>
                    <img
                      src={ARTE_CAN}
                      className="md:mr-3 md:h-56"
                      alt="HackTricks Training Logo"
                    />
                  </div>
                  <div className="">
                    <h1 className="text-3xl md:text-5xl font-bold text-center dark:text-white mt-8 md:mt-0">
                      HACKTRICKS ARTE
                    </h1>
                    <h2 className="text-2xl md:text-3xl font-medium text-center dark:text-white">
                      {arte ? arte?.title.toUpperCase() : "No course data"}
                    </h2>
                  </div>
                </div>

                <div className="mt-3 md:mt-6 mx-3 md:mx-16 grid grid-cols-1 justify-items-center dark:text-white">
                  <div className="px-10 md:px-16">
                    <p className="text-justify mt-3 md:mt-5">
                      {arte ? arte?.description : "No course data"}
                    </p>
                  </div>
                </div>
                <div className="mx-3 md:mx-16 mt-10 md:mt-10 grid grid-cols-1 sm:grid-cols-2 justify-items-center dark:text-white">
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">20+</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        HOURS OF VIDEO LESSONS
                      </h3>
                    </div>
                  </div>
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">70+</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        ESTIMATED HOURS COMPLETION TIME
                      </h3>
                    </div>
                  </div>
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">50+</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        HANDS-ON LABS TO TRAIN
                      </h3>
                    </div>
                  </div>
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">1</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        EXAM TO PROVE YOUR KNOWLEDGE
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="mx-20 sm:mx-0 grid grid-cols-1 gap-x-20 gap-y-8 sm:grid-cols-2 mt-10 mb-20">
                  <div className="flex flex-col sm:items-end">
                    <Button
                      as={Link}
                      size="xl"
                      className="text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                      outline={true}
                      to={`/courses/${arte?.slug}`}
                    >
                      {/* ENROLL NOW */}
                      MORE INFO
                    </Button>
                  </div>
                  <>
                    {arte ? (
                      <>
                        <ModalCustomLanding
                          title={"Get " + arte?.title + " now"}
                        >
                          <div className="p-6">
                            <div className="space-y-6">
                              <div className={!errModalMsg ? "sr-only" : ""}>
                                <Alert
                                  color="failure"
                                  icon={ExclamationTriangleIcon}
                                  onDismiss={function onDismiss() {
                                    setErrModalMsg("")
                                  }}
                                >
                                  <span ref={errModalRef}>{errModalMsg}</span>
                                </Alert>
                              </div>
                              {arte?.max_sales ? (
                                <Alert
                                  className=""
                                  color="warning"
                                  icon={ExclamationTriangleIcon}
                                >
                                  To ensure the best quality of our service, for
                                  the time being, we are limiting this course to{" "}
                                  {arte?.max_sales} students.
                                </Alert>
                              ) : (
                                <></>
                              )}
                              <div className="text-base leading-relaxed text-neutral-700 dark:text-white">
                                Includes:
                                <ul className="list-disc list-inside">
                                  <li>20+ hours of video lessons</li>
                                  <li>60 days of access to 50+ labs</li>
                                  <li>1 certification exam attempt</li>
                                </ul>
                              </div>
                              <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                                Price: {arte?.price}€
                              </div>

                              <div className="flex flex-col items-center">
                                <TextInput
                                  id="quantity"
                                  type="number"
                                  placeholder="1"
                                  addon="Quantity"
                                  required={true}
                                  onChange={(e) => {
                                    if (
                                      parseInt(e.target.value) > 0 ||
                                      e.target.value === ""
                                    ) {
                                      setQuantity(e.target.value)
                                    }
                                  }}
                                  onFocus={() => setQuantityFocus(true)}
                                  onBlur={() => setQuantityFocus(false)}
                                  value={quantity}
                                  aria-invalid={
                                    validQuantity ? "false" : "true"
                                  }
                                  color={
                                    validQuantity
                                      ? ""
                                      : !quantity
                                      ? ""
                                      : "failure"
                                  }
                                  theme={{ field: { base: "relative w-16" } }}
                                  helperText={
                                    <>
                                      <span
                                        className={
                                          quantityFocus &&
                                          quantity &&
                                          !validQuantity
                                            ? ""
                                            : "sr-only"
                                        }
                                      >
                                        <ExclamationCircleIcon className="mr-3 inline h-5 w-5 flex-shrink-0" />
                                        Invalid quantity, must be greater than 0
                                      </span>
                                    </>
                                  }
                                />
                              </div>
                              {arte?.promotion ? (
                                <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center ">
                                  <Alert
                                    className="my-6 md:w-1/2 lg:w-1/3 mx-3 md:mx-auto"
                                    color="failure"
                                    icon={ExclamationCircleIcon}
                                  >
                                    Early bird discount will end on{" "}
                                    <strong>February 9th 2024</strong>. You can
                                    purchase your voucher now with the discount
                                    and activate it at any point in the next
                                    year.
                                  </Alert>
                                  <span className="text-red-700 dark:text-red-500 line-through">
                                    Total:{" "}
                                    {arte?.price *
                                      (quantity ? parseInt(quantity) : 0)}
                                    €
                                  </span>
                                  <br />
                                  Promotion: -{arte?.promotion}€ <br />
                                  <span className="text-green-600 dark:text-green-400">
                                    New total:{" "}
                                    {arte?.price *
                                      (quantity ? parseInt(quantity) : 0) -
                                      arte?.promotion}
                                    €
                                  </span>
                                </div>
                              ) : (
                                <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                                  Total:
                                  {arte?.price *
                                    (quantity ? parseInt(quantity) : 0)}
                                  €
                                </div>
                              )}
                              <div className="flex flex-col items-center">
                                <Button
                                  className="items-center text-neutral-700 dark:text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                                  type="button"
                                  onClick={() => buy(arte?.slug, quantity)}
                                  disabled={!validQuantity}
                                >
                                  Buy now
                                </Button>
                              </div>
                            </div>
                          </div>
                        </ModalCustomLanding>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                </div>
              </section>
              <section
                id="cert_arta"
                className="my-16 mx-3 md:mx-24 pt-10 border-dashed border-4 border-amber-500 rounded-3xl"
              >
                <div className="md:flex justify-center items-center">
                  <div>
                    <img
                      src={ARTA_CAN}
                      className="md:mr-3 md:h-56"
                      alt="HackTricks Training Logo"
                    />
                  </div>
                  <div className="">
                    <h1 className="text-3xl md:text-5xl font-bold text-center dark:text-white mt-8 md:mt-0">
                      HACKTRICKS ARTA
                    </h1>
                    <h2 className="text-2xl md:text-3xl font-medium text-center dark:text-white">
                      {arta ? arta?.title.toUpperCase() : "No course data"}
                    </h2>
                  </div>
                </div>

                <div className="mt-3 md:mt-6 mx-3 md:mx-16 grid grid-cols-1 justify-items-center dark:text-white">
                  <div className="px-10 md:px-16">
                    <p className="text-justify mt-3 md:mt-5">
                      {arta ? arta?.description : "No course data"}
                    </p>
                  </div>
                </div>
                {/* <div className="mx-3 md:mx-64 mt-6 md:mt-10">
                  <ReactPlayer
                    controls={true}
                    width="100%"
                    height="100%"
                    className="aspect-video"
                    url="https://youtu.be/Aizjgeq1Yek"
                  />
                </div> */}
                <div className="mx-3 md:mx-16 mt-10 md:mt-10 grid grid-cols-1 sm:grid-cols-2 justify-items-center dark:text-white">
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">8+</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        HOURS OF VIDEO LESSONS
                      </h3>
                    </div>
                  </div>
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">25+</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        ESTIMATED HOURS COMPLETION TIME
                      </h3>
                    </div>
                  </div>
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">20+</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        HANDS-ON LABS TO TRAIN
                      </h3>
                    </div>
                  </div>
                  <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                    <div className="flex-none">
                      <h1 className="text-5xl font-bold text-amber-500">1</h1>
                    </div>
                    <div className="grow ml-3">
                      <h3 className="text-xl font-bold">
                        CERTIFICATE OF COMPLETION
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="mx-20 sm:mx-0 grid grid-cols-1 gap-x-20 gap-y-8 sm:grid-cols-2 mt-10 mb-20">
                  <div className="flex flex-col sm:items-end">
                    <Button
                      as={Link}
                      size="xl"
                      className="text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                      outline={true}
                      to={`/courses/${arta?.slug}`}
                    >
                      {/* ENROLL NOW */}
                      MORE INFO
                    </Button>
                  </div>
                  <>
                    {arta ? (
                      <>
                        <ModalCustomLanding
                          title={"Get " + arta?.title + " now"}
                        >
                          <div className="p-6">
                            <div className="space-y-6">
                              <div className={!errModalMsg ? "sr-only" : ""}>
                                <Alert
                                  color="failure"
                                  icon={ExclamationTriangleIcon}
                                  onDismiss={function onDismiss() {
                                    setErrModalMsg("")
                                  }}
                                >
                                  <span ref={errModalRef}>{errModalMsg}</span>
                                </Alert>
                              </div>
                              {arta?.max_sales ? (
                                <Alert
                                  className=""
                                  color="warning"
                                  icon={ExclamationTriangleIcon}
                                >
                                  To ensure the best quality of our service, for
                                  the time being, we are limiting this course to{" "}
                                  {arta?.max_sales} students.
                                </Alert>
                              ) : (
                                <></>
                              )}
                              <div className="text-base leading-relaxed text-neutral-700 dark:text-white">
                                Includes:
                                <ul className="list-disc list-inside">
                                  <li>8+ hours of video lessons</li>
                                  <li>30 days of access to 20+ labs</li>
                                  <li>1 certificate of completion</li>
                                </ul>
                              </div>
                              <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                                Price: {arta?.price}€
                              </div>

                              <div className="flex flex-col items-center">
                                <TextInput
                                  id="quantity"
                                  type="number"
                                  placeholder="1"
                                  addon="Quantity"
                                  required={true}
                                  onChange={(e) => {
                                    if (
                                      parseInt(e.target.value) > 0 ||
                                      e.target.value === ""
                                    ) {
                                      setQuantity(e.target.value)
                                    }
                                  }}
                                  onFocus={() => setQuantityFocus(true)}
                                  onBlur={() => setQuantityFocus(false)}
                                  value={quantity}
                                  aria-invalid={
                                    validQuantity ? "false" : "true"
                                  }
                                  color={
                                    validQuantity
                                      ? ""
                                      : !quantity
                                      ? ""
                                      : "failure"
                                  }
                                  theme={{ field: { base: "relative w-16" } }}
                                  helperText={
                                    <>
                                      <span
                                        className={
                                          quantityFocus &&
                                          quantity &&
                                          !validQuantity
                                            ? ""
                                            : "sr-only"
                                        }
                                      >
                                        <ExclamationCircleIcon className="mr-3 inline h-5 w-5 flex-shrink-0" />
                                        Invalid quantity, must be greater than 0
                                      </span>
                                    </>
                                  }
                                />
                              </div>
                              {arta?.promotion ? (
                                <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center ">
                                  <Alert
                                    className="my-6 md:w-1/2 lg:w-1/3 mx-3 md:mx-auto"
                                    color="failure"
                                    icon={ExclamationCircleIcon}
                                  >
                                    Early bird discount will end on{" "}
                                    <strong>February 9th 2024</strong>. You can
                                    purchase your voucher now with the discount
                                    and activate it at any point in the next
                                    year.
                                  </Alert>
                                  <span className="text-red-700 dark:text-red-500 line-through">
                                    Total:{" "}
                                    {arta?.price *
                                      (quantity ? parseInt(quantity) : 0)}
                                    €
                                  </span>
                                  <br />
                                  Promotion: -{arta?.promotion}€ <br />
                                  <span className="text-green-600 dark:text-green-400">
                                    New total:{" "}
                                    {arta?.price *
                                      (quantity ? parseInt(quantity) : 0) -
                                      arta?.promotion}
                                    €
                                  </span>
                                </div>
                              ) : (
                                <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                                  Total:
                                  {arta?.price *
                                    (quantity ? parseInt(quantity) : 0)}
                                  €
                                </div>
                              )}
                              <div className="flex flex-col items-center">
                                <Button
                                  className="items-center text-neutral-700 dark:text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                                  type="button"
                                  onClick={() => buy(arta?.slug, quantity)}
                                  disabled={!validQuantity}
                                >
                                  Buy now
                                </Button>
                              </div>
                            </div>
                          </div>
                        </ModalCustomLanding>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                </div>
              </section>
            </>
          )}
        </div>
      </div>
      <Footer />
    </section>
  )
}

export default Landing
